import { ColumnDefinitionEnumType } from '@mark43/cad-api';
import { useMemo } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import columnDefinitionEnum from '../../queues/column-definition.enum';

type ColumnDisplayName = {
    displayName: string;
    displayAbbreviation: string;
};

export function useColumnDisplayNames(): Record<ColumnDefinitionEnumType, ColumnDisplayName> {
    const { primaryPoliceSubdivisionName, fieldDisplayNameByFieldName } = useBootstrapState();
    const { multiAgencySubdivisions } = useEnabledFeatures();
    return useMemo(() => {
        const columnDisplayNames: Partial<Record<ColumnDefinitionEnumType, ColumnDisplayName>> = {};
        for (const [columnName, columnDefinitionData] of Object.entries(columnDefinitionEnum)) {
            if (columnName === columnDefinitionEnum.BEAT.name) {
                if (multiAgencySubdivisions) {
                    columnDisplayNames[columnName] = {
                        displayName: `Event ${fieldDisplayNameByFieldName.DISPLAY_PRIMARY_SUBDIVISION}`,
                        displayAbbreviation: `E. ${fieldDisplayNameByFieldName.DISPLAY_PRIMARY_SUBDIVISION}`,
                    };
                } else {
                    columnDisplayNames[columnName] = {
                        displayName: `Event ${primaryPoliceSubdivisionName}`,
                        displayAbbreviation: `E. ${primaryPoliceSubdivisionName}`,
                    };
                }
            } else if (columnName === columnDefinitionEnum.UNIT_BEAT.name) {
                if (multiAgencySubdivisions) {
                    columnDisplayNames[columnName] = {
                        displayName: `Unit ${fieldDisplayNameByFieldName.DISPLAY_PRIMARY_SUBDIVISION}`,
                        displayAbbreviation: `U. ${fieldDisplayNameByFieldName.DISPLAY_PRIMARY_SUBDIVISION}`,
                    };
                } else {
                    columnDisplayNames[columnName] = {
                        displayName: `Unit ${primaryPoliceSubdivisionName}`,
                        displayAbbreviation: `U. ${primaryPoliceSubdivisionName}`,
                    };
                }
            } else {
                columnDisplayNames[columnName as ColumnDefinitionEnumType] = {
                    displayName: columnDefinitionData.displayName,
                    displayAbbreviation: columnDefinitionData.columnAbbreviation,
                };
            }
        }
        return columnDisplayNames as Record<ColumnDefinitionEnumType, ColumnDisplayName>;
    }, [primaryPoliceSubdivisionName, fieldDisplayNameByFieldName, multiAgencySubdivisions]);
}
